import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const SmsTrackingLog = React.lazy(() =>
    import('../SmsTrackingLog')
);
const smsTrackingLogRoutesRegistry = [
    {
        path: PAGE_URL.SMS_TRACKING_LOG_PAGE,
        element: <SmsTrackingLog />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default smsTrackingLogRoutesRegistry;
